import Entry from "pages/Entry";
import Home from "pages/Home";
import Rabar from "pages/Rabar";
import Pranzi from "pages/Pranzi";
import Cene from "pages/Cene";
import Eventi from "pages/Eventi";
import Storia from "pages/Storia";
import Contatti from "pages/Contatti";

import {
	home,
	entry,
	rabar,
	pranzi,
	cene,
	eventiPage,
	serviziPage,
	contattiPage,
	storiaPage,
} from "site-structure.js";

const appname = process.env.REACT_APP_WEBSITE_NAME;

const routes = [
	{
		key: "home",
		...entry,
		hasChild: false,
		component: <Entry title={entry.pageTitle} />,
		visible: true,
	},
	{
		key: "rabarbaro",
		...home,
		hasChild: false,
		component: <Home title={home.pageTitle} />,
		visible: true,
	},
	{
		key: "rabar",
		...rabar,
		hasChild: false,
		component: <Rabar title={rabar.pageTitle} />,
		visible: true,
	},
	{
		key: "pranzi",
		...pranzi,
		hasChild: false,
		component: <Pranzi title={pranzi.pageTitle} />,
		visible: false,
	},
	{
		key: "cene",
		...cene,
		hasChild: false,
		component: <Cene title={cene.pageTitle} />,
		visible: false,
	},
	// {
	// 	key: "eventi",
	// 	...eventiPage,
	// 	component: <Eventi title={`${eventiPage.pageTitle} - ${appname}`} />,
	// 	visible: true,
	// },
	{
		key: "servizi",
		...serviziPage,
		hasChild: true,
		component: <Eventi title={serviziPage.pageTitle} />,
		visible: true,
	},
	{
		key: "storia",
		...storiaPage,
		hasChild: false,
		component: <Storia title={storiaPage.pageTitle} />,
		visible: true,
	},
	{
		key: "contatti",
		...contattiPage,
		hasChild: false,
		component: <Contatti title={contattiPage.pageTitle} />,
		visible: true,
	},
];

export { routes };
